<script setup lang="ts">
const items = computed(() => [
  {
    label: 'Game Hosting Plans',
    to: '/plans'
  },
  {
    label: 'Affiliate',
    to: '/affiliate'
  },
  {
    label: 'Company',
    to: '/company'
  },
  {
    label: 'Support',
    to: '/support'
  }
])
</script>

<template>
  <UHeader
    :ui="{
      wrapper: 'fixed top-0 left-0 right-0 z-50 border-none bg-transparent shadow-none backdrop-blur-none !bg-transparent !bg-none !shadow-none !backdrop-blur-none !h-0',
      container: 'bg-white/5 backdrop-blur-[19.5px] border border-white/20 rounded-2xl mt-4 px-5 py-2 mx-auto max-w-6xl shadow-[0_4px_12px_rgba(31,29,25,0.17)]'
    }"
  >
    <template #left>
      <NuxtLink
        to="/"
        class="text-white font-bold text-base w-27.25 text-center"
      >
        Velara Hosting
      </NuxtLink>
    </template>

    <UNavigationMenu
      :items="items"
      variant="link"
      :ui="{
        link: 'text-white/100 hover:text-primary-500 transition-colors text-sm font-medium tracking-[0.14px]'
      }"
    />

    <template #right>
      <div class="flex items-center gap-1">
        <UButton
          label="Login"
          color="neutral"
          variant="ghost"
          to="/login"
          class="hidden lg:inline-flex text-white hover:bg-transparent hover:text-white/80 px-5 py-3 h-9 rounded-[11px] text-sm font-medium capitalize"
        />

        <UButton
          label="Sign Up"
          color="primary"
          to="/signup"
          class="hidden lg:inline-flex h-9 px-5 py-3 rounded-[11px] bg-gradient-to-b from-[#15923a] to-[#23a328] border border-[#19b647] text-white text-sm font-medium capitalize shadow-[inset_0_2px_8px_rgba(255,255,255,0.45)] hover:from-[#15923a]/90 hover:to-[#23a328]/90 transition-all duration-300"
        />
      </div>
    </template>

    <template #body>
      <UNavigationMenu
        :items="items"
        orientation="vertical"
        class="-mx-2.5"
      />

      <USeparator class="my-6" />

      <UButton
        label="Login"
        color="neutral"
        variant="subtle"
        to="/login"
        block
        class="mb-3 rounded-[11px] h-10 capitalize"
      />
      <UButton
        label="Sign Up"
        color="primary"
        to="/signup"
        block
        class="rounded-[11px] h-10 bg-gradient-to-b from-[#15923a] to-[#23a328] border border-[#19b647] text-white shadow-[inset_0_2px_8px_rgba(255,255,255,0.45)] capitalize"
      />
    </template>
  </UHeader>
</template>
